import React, { useState, useEffect, useRef } from 'react';
import axios from 'axios'; // Import axios
import '../App.css';
import './contact.css';
import ReCAPTCHA from 'react-google-recaptcha';


function ContactForm() {

  const recaptchaRef = useRef(null);

  const [formData, setFormData] = useState({
    firstName: '',
    lastName: '',
    email: '',
    phoneNumber: '',
    company: '',
    serviceOfInterest: '',
    message: '',
    bot_field: '',
    //recaptchaToken: '',
  });

  //const [recaptchaToken, setRecaptchaToken] = useState(null);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  /*const handleRecaptcha = async () => {
    try {
      const token = await window.grecaptcha.execute();
      setFormData((prevState) => ({
        ...prevState,
        recaptchaToken: token,
      }));
    } catch (error) {
      console.error('Error executing reCAPTCHA:', error);
    }
  };*/


  const handleSubmit = async (e) => {
    e.preventDefault();

    //await handleRecaptcha();

    // Ensure the reCAPTCHA token is set
    //if (!formData.recaptchaToken) {
     // alert('Please Push " Contact Us" Again');
      //return;
    //}
    // ✅ Honeypot check
    if (formData.bot_field) {
      console.warn('Bot submission detected, ignoring.');
      return;
    }

     const recaptchaToken = recaptchaRef.current.getValue();
    if (!recaptchaToken) {
      alert('Please complete the reCAPTCHA checkbox before submitting.');
      return;
    }
    
    try {
      // Send form data to the server
      const response = await axios.post('https://api.samstreeservice.com/api/contact',{...formData,recaptchaToken,});


      // Handle the response as needed
      console.log('Server Response:', response.data);

      // Reset the form fields
      setFormData({
        firstName: '',
        lastName: '',
        email: '',
        phoneNumber: '',
        company: '',
        serviceOfInterest: '',
        message: '',
        bot_field: '', 
        //recaptchaToken: '',
      });

      recaptchaRef.current.reset();

      alert('Your information was submitted successfully!');
    } catch (error) {
      console.error('Error submitting form:', error);
      alert('Error submitting form. Please try again.');
    }
  };


  

  return (
    <div id='formcontainer'>
      <div id='contact_form_title'><h1>Reach Out Today!</h1></div>
      <form onSubmit={handleSubmit}>
         {/* Honeypot field (hidden from users) */}
        <input
          type="text"
          name="bot_field"
          value={formData.bot_field}
          onChange={handleChange}
          style={{ display: 'none' }}
          tabIndex="-1"
          autoComplete="off"
        />

        <div id='firstnamediv' className="form-group">
          <input
            type="text"
            id="firstName_con"
            name="firstName"
            placeholder="First Name:"
            htmlFor="firstName"
            value={formData.firstName}
            onChange={handleChange}
            required
            
          />
        </div>
        
        <div id='emaildiv' className="form-group">
          <input
            type="email"
            id="email_con"
            name="email"
            placeholder="Email:"
            htmlFor="email"
            value={formData.email}
            onChange={handleChange}
            required
            
          />
        </div>
        <div id='phonediv' className="form-group">
          <input
            type="text"
            id="phone_number_con"
            name="phoneNumber"
            placeholder="Phone#:"
            htmlFor="phoneNumber"
            value={formData.phoneNumber}
            onChange={handleChange}
            required
            
          />
        </div>
        <div id='messagediv' className="form-group">
          <textarea
            id="message_con"
            name="message"
            placeholder="Message:"
            htmlFor="message"
            value={formData.message}
            onChange={handleChange}
            required
            
          ></textarea>
        </div>

        {/* reCAPTCHA checkbox */}
        <div id="ReCAPTCHA" className="form-group">
            <ReCAPTCHA
              ref={recaptchaRef}
              sitekey="6LdwstIpAAAAAL1_lBneLQEQRHpyUpxdO5ZXJ0R9" 
            />
        </div>

        <button id='formbutton_contact' type="submit">Contact US</button>
      </form>
    </div>
  );
}

export default ContactForm;

/*<ReCAPTCHA id='recaptcha'
          sitekey="" 
          size="invisible"
          onChange={handleRecaptcha}
        />
        
        
  <div id='lastnamediv' className="form-group">
          <input
            type="text"
            id="lastName"
            name="lastName"
            placeholder="Last Name:"
            htmlFor="lastName"
            value={formData.lastName}
            onChange={handleChange}
            required
            style={{ width: '90%', padding: '10px', 
            border: '2px solid #ccc', borderRadius: '5px', fontSize: '14px' }}
          />
        </div>      
        
        
        style={{ width: '90%', padding: '10px', 
            border: '1px solid #ccc', borderRadius: '5px', fontSize: '14px' }}

            style={{ width: '90%', padding: '10px', 
            border: '1px solid #ccc', borderRadius: '5px', fontSize: '14px' }}

            style={{ width: '94.5%', padding: '10px', marginLeft: '1%',
            border: '1px solid #ccc', borderRadius: '5px', fontSize: '14px' }}
        
*/